import { makeTranslations } from "$utils/i18n"

import * as translations from "./**/en.yml"

export default makeTranslations(translations)
